import { authManager } from '@/features/auth/mirrorfly/authUtils';
import { handleMediaAction } from '@/features/chats/services/messageQueueManager';
import { cancelUpload as cancelMediaUpload } from '@/features/chats/services/messageQueue';
import { DOWNLOAD_STATUS, UPLOAD_STATUS } from '@/shared/constants';
import storage from '@/shared/utils/storage';
import { store } from '@/app/store';
import { setAppOnlineStatus } from '@/app/store/navigationSlice';

const UPLOADING_STATUSES = new Set([UPLOAD_STATUS.PENDING, UPLOAD_STATUS.IN_PROGRESS, UPLOAD_STATUS.QUEUED]);

const collectLeaves = msg => (msg?.type === 'groupedMedia' ? (msg.messages ?? []) : [msg]);

const cancelActiveMediaTransfers = () => {
   const conversationData = store.getState().conversationData?.data ?? {};
   for (const [chatId, chatData] of Object.entries(conversationData)) {
      for (const msg of chatData?.messages ?? []) {
         for (const leaf of collectLeaves(msg)) {
            const media = leaf?.msgBody?.media;
            if (!media) continue;

            if (UPLOADING_STATUSES.has(media.is_uploading)) {
               cancelMediaUpload(leaf.msgId, chatId);
            }
            if (media.is_downloaded === DOWNLOAD_STATUS.IN_PROGRESS) {
               handleMediaAction(leaf, 'cancelDownload');
            }
         }
      }
   }
};

export const setupNetworkListeners = () => {
   window.addEventListener('offline', () => {
      store.dispatch(setAppOnlineStatus({ isOnline: false }));
      authManager.setDisconnected(true);
      cancelActiveMediaTransfers();
   });

   window.addEventListener('online', () => {
      store.dispatch(setAppOnlineStatus({ isOnline: true }));

      if (storage.getItem('username')) {
         // Trigger reconnect — may be a no-op if initialize.js's CONNECTED
         // handler already started it (guard: isReconnecting check).
         authManager.isReconnecting = false;
         authManager.mirrorflyReconnectWithRetries();
      }
   });
};
